import React from 'react';
import PropTypes from 'prop-types';

const Script = ({url, onLoad, children, wait=true}) => {
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    const script = document.createElement('script');
    document.body.appendChild(script);

    script.onload = () => {
      setLoaded(true);
      if (onLoad) onLoad(true);
    };
    script.src = url;
    script.async = true;


    return () => {
      document.body.removeChild(script);
    };
  }, [url, onLoad]);

  if (wait && !loaded) return null;
  return children;
};

Script.propTypes = {
  url: PropTypes.string.isRequired,
  onLoad: PropTypes.func,
  children: PropTypes.node,
  wait: PropTypes.bool,
};

export default Script;
